function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      // Prefer Rebuy Smart Cart when present
      if (window.Rebuy?.SmartCart && typeof Rebuy.SmartCart.show === 'function') {
        Rebuy.SmartCart.show();
        return;
      }

      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
